export * from './src/ecom-discounts-v1-discount-rule-discount-rules.meta.js';
